import React, {useState, useEffect, useContext} from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { PassengerAPI } from '../../../../../../API/PassengerAPIs/PassengerAPIs';
import STC from '../../../../../../STCLibrary/STCFactory/STCFactory';
import PaymentHistoryTableRow from './PaymentHistoryTableRow/PaymentHistoryTableRow';
import PaymentReceipt from './PaymentReceipt/PaymentReceipt';
import NotificationContext from '../../../../../../STCLibrary/NotificationSystem/NotificationContext';
import ApiResponseHandler from '../../../../../../STCLibrary/ApiResponseHandler/ApiResponseHandler';
import PaymentGlobalReceiptRow from './PaymentGlobalReceiptRow/PaymentGlobalReceiptRow';

export default function PaymentHistoryTable(){

  const routeParams = useParams();
  const notificationCtx = useContext(NotificationContext);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [passengerData, setPassengerData] = useState([]);
  
  const [chosenPax, setChosenPax] = useState('');
  const [showReceipt, setShowReceipt] = useState(false);

  const [selectedPayment, setSelectedPayment] = useState();

  const ColumnHeaders = ['Passenger', 'Booking ID', 'Amount', 'Date',
    //  'Receipt'
    ];

  const chosenPassenger = (id) => {
    const passenger = passengerData.filter((pax) => pax.id === parseInt(id))
    return passenger[0];
  }

  const handleChoosePax = (e) => {
    setChosenPax(e.target.value);
    setShowReceipt(false);
    setSelectedPayment(null);
  }
  

  const thData = () => {
    return ColumnHeaders.map((title, index) => {
        return(
            <th key={index}>{title}</th>
        )
    })
  }

  const handleOpenReceipt = (payment) => {
    setSelectedPayment(payment);
    setShowReceipt(true);
  }

  

    const getPassengers = () => {
        PassengerAPI.GetPortalPassengers(routeParams.userID)
        .then((response) => {
            if(response.status === 200){
                setPassengerData(response.data);
                setLoading(false);
            }
        })
        .catch((err) => {
            console.log(err);
            ApiResponseHandler(err.response, notificationCtx, navigate);
        })
      }


      useEffect(() => {
        getPassengers();
      }, []);

  if(loading){
    return(
      <div>Loading your passengers...</div>
    )
  }
  else{
  return(
      <div>
        <h4>Successful Payments</h4>
        <div className='m-2'>
            <STC.Link 
                to={`/${routeParams.userID}/passengers`} 
                style={{textDecoration: 'none', color: 'black'}}
            >
                <STC.Button>Make a new payment</STC.Button>
            </STC.Link>
        </div>
        <STC.Form.Select className='mb-2' value={chosenPax} onChange={handleChoosePax}>
            <option value=''>All</option>
            {passengerData.map((passenger) => {
                return(
                    <option key={passenger.id} value={passenger.id}>{passenger.firstName} {passenger.surname}</option>
                )
            })}
        </STC.Form.Select>
        <STC.Table size={'sm'} hover striped responsive>
            <thead>
                <tr>{thData()}</tr>
            </thead>
            <tbody>
            {chosenPax === '' ? 
            
            passengerData.map((passenger) => {
                return(
                    
                    <PaymentHistoryTableRow key={passenger.id} handleOpenReceipt={handleOpenReceipt} passenger={passenger}/>
                    // <PaymentGlobalReceiptRow key={passenger.id} handleOpenReceipt={handleOpenReceipt} passenger={passenger}/>
                    
                )
            })
            :
            <PaymentHistoryTableRow handleOpenReceipt={handleOpenReceipt} passenger={chosenPassenger(chosenPax)}/>
            // <PaymentGlobalReceiptRow handleOpenReceipt={handleOpenReceipt} passenger={chosenPassenger(chosenPax)}/>
            }
            </tbody>
        </STC.Table>   

      
        {showReceipt &&
          <PaymentReceipt passenger={chosenPassenger(selectedPayment.portalPassengerId)}  payment={selectedPayment} />
        }
        
      </div>
  )
}
}